export default "__VITE_ASSET__4d4f27bc__"